import React from 'react';
import PropTypes from 'prop-types';
import styled, { keyframes } from 'styled-components';
import styles from '../../../styles';

const loop = keyframes`
  50% {
    transform: translate3d(100%, 0, 0);
    opacity: 0;
  }
  50.01% {
    visibility: hidden;
    transform: translate3d(-50%, 0, 0);
  }
  50.02% {
    visibility: visible;
  }
  100% {
    opacity: 1;
    transform: translate3d(0%, 0, 0);
  }
`;

const line = keyframes`
  50% {
    transform: scale(0, 1) translate3d(0,0,0);
  }
  50.02% {
    transform: scale(2, 1) translate3d(0,0,0);
  }
  100% {
    transform: scale(1, 1) translate3d(0,0,0);
  }
`;

const StyledArrow = styled.figure`
  color: ${styles.color.ORANGE};
  width: 1.5em;
  font-size: inherit;
  transform: translate3d(0, 0, 0);

  svg {
    transition-property: transform, opacity;
    transition-duration: 0.175s;
    transition-timing-function: ${styles.easing.inQuad};

    line {
      transition-property: transform, opacity;
      transition-duration: 0.175s;
      transition-timing-function: ${styles.easing.inQuad};
    }
  }

  &.hover {
    svg {
      animation-name: ${loop};
      line {
        animation-name: ${line};
      }
    }
  }

  svg {
    overflow: visible;
    animation-fill-mode: forwards;
    animation-timing-function: ${styles.easing.inOutQuad};
    animation-duration: 0.35s;
    line,
    polyline {
      fill: none;
      stroke: currentColor;
      stroke-width: 2px;
    }
    line {
      animation-fill-mode: forwards;
      animation-timing-function: ${styles.easing.outBack};
      animation-duration: 0.55s;
      transform-origin: 100% 0;
    }
  }
`;

const LinkArrow = props => {
  const { className, reverse } = props;
  return (
    <StyledArrow className={className}>
      {reverse ? (
        <svg viewBox="0 0 42 36">
          <line x1="0" y1="18" x2="42" y2="18" />
          <polyline points="10,9 0,18 10,27" />
        </svg>
      ) : (
        <svg viewBox="0 0 42 36">
          <line x1="0" y1="18" x2="42" y2="18" />
          <polyline points="32,9 42,18 32,27" />
        </svg>
      )}
    </StyledArrow>
  );
};

LinkArrow.propTypes = {
  className: PropTypes.string,
  reverse: PropTypes.bool,
};

export default LinkArrow;



// WEBPACK FOOTER //
// ./src/modules/pages/components/LinkArrow.js